import { isEmpty, isUndefined } from 'lodash';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { FilterEqualTypeInput } from '~/constants/ProductAttributeFilterInput';
import { converShortCodeFilterKey } from '~/utils/converters';
import { createSortObject } from '~/utils/filter';

const displayFilter = ['category_master', 'color', 'price', 'is_product_note', 'max_price', 'min_price'];

const exceptionsKey: string[] = [
    'pageSize',
    'currentPage',
    'sort'
    // 'category_master',
    // 'color',
    // 'price',
    // 'is_product_note',
    // 'max_price',
    // 'min_price',
];

const shortCodeList = {
    Category: ' ca',
    type: ' ty',
    Color: ' co',
    Size: ' si',
    Frame: 'fr',
    Style: ' st'
};

export const useGetFilterValues = () => {
    const router = useRouter();
    const sort = router?.query?.sort as string;
    const filter = converShortCodeFilterKey(
        (router?.query as any) || {
            pageSize: 30,
            currentPage: 1
        },
        'decode'
    );

    const { pageSize, currentPage } = filter || {};

    return {
        filterValues: filter,
        pageSize,
        currentPage,
        sort: createSortObject(sort as string, '-')
    };
};
